"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUniqueCancellationPolicies = void 0;
const extractUniqueCancellationPolicies = (data) => {
    const uniquePolicies = new Map();
    data.forEach((item) => {
        const policy = item?.cancellation_policy;
        if (policy && !uniquePolicies.has(policy.id)) {
            uniquePolicies.set(policy.id, policy);
        }
    });
    return Array.from(uniquePolicies.values());
};
exports.extractUniqueCancellationPolicies = extractUniqueCancellationPolicies;
